module.exports = require("@splunk/react-docs/DocExample");